export default __webpack_public_path__ + "static/media/Search-icon.a1ea6468.svg";